import axiosInstance from "../../api/axiosInstance";

export const fetchCurrentUser = async () => {
  const res = await axiosInstance.get("/api/auth/me");
  // console.log("userInfo", res.data)
  return res.data;
};

export const logout = async () => {
  await axiosInstance.post("/api/auth/logout");
  if(process.env.REACT_APP_SOURCE_TYPE  === "staging") {
    window.location.href = ('https://www.insione.com/')
  } else {
    window.location.href = ('/login')
  }
};
